(function () {
	'use strict';
	var $ = avm.require('cash'),
		$question = $('.question');

	$(document).ready(function () {

		$question.on('click', function () {
			var arrow = $(this).find('span');

			if (arrow.css("transform") === "none") {
				arrow.css("transform", "rotateX(180deg)");
			} else {
				arrow.css("transform", "none");
			}

		});
	});
})();
